<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  title: { type: String, default: 'Pronto, visita confirmada!' },
  actionLabel: { type: String, default: 'Ir para agenda' },
});

const emit = defineEmits(['action']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="grid gap-4 text-center">
    <span
      class="mx-auto grid size-14 place-items-center rounded-full bg-lais-success/10 text-lais-success"
    >
      <span class="i-lucide-check size-7" aria-hidden="true" />
    </span>
    <h2 class="font-redHatDisplay text-[24px] font-semibold text-lais-text">
      {{ title }}
    </h2>
    <div class="grid gap-2 text-left text-[13px] text-lais-text-body">
      <p class="flex gap-2">
        <span class="i-lucide-calendar-check size-4 text-lais-primary" />
        A visita já aparece na agenda do corretor.
      </p>
      <p class="flex gap-2">
        <span class="i-lucide-key-round size-4 text-lais-primary" />
        Confira a entrada e as chaves antes do horário.
      </p>
      <p class="flex gap-2">
        <span class="i-lucide-file-text size-4 text-lais-primary" />
        Leve as orientações do imóvel para o atendimento.
      </p>
    </div>
    <button
      type="button"
      class="rounded-lais bg-lais-primary px-4 py-2 text-[14px] font-semibold text-white"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </section>
</template>
